import { client } from './api-client';

export const fetchSubscriptionsProducts = () => client.get(`products`);
export const fetchSubscriptionsProductsExternal = () =>
  client.get(`products`, {
    headers: { Accept: 'application/vnd.briz.external.v1+json' }
  });
export const fetchSubscriptionsProductsWithChannels = () => client.get(`tv/channels-grouped`);
export const restoreSubscriptionApi = (body) => client.post('subscribe', body);
